// extracted by mini-css-extract-plugin
export default {"addToParentIconGroupedContainer":"QuestionContainerLockState_addToParentIconGroupedContainer__Dcmyz"};